// Form state can omit adsGroups until a campaign payload is applied.
// Callers that read the list during render must tolerate that gap.

export const toAdsGroupsList = (adsGroups) =>
  Array.isArray(adsGroups) ? adsGroups : [];

export const findAdsGroupIndexById = ({ adsGroups, adGroupID }) =>
  toAdsGroupsList(adsGroups).findIndex((item) => item?.id === adGroupID);

export const findAdIndexById = ({ ads, adID }) =>
  (Array.isArray(ads) ? ads : []).findIndex((item) => item?.id === adID);

export const isAdPresentInAdsGroups = ({ adsGroups, adGroupID, adID }) => {
  const adGroupIndex = findAdsGroupIndexById({ adsGroups, adGroupID });
  if (adGroupIndex < 0) {
    return false;
  }
  return (
    findAdIndexById({
      ads: adsGroups[adGroupIndex]?.ads,
      adID,
    }) >= 0
  );
};

export const isSectionSelectionAvailable = ({
  levelSectionSelected,
  adsGroups,
  adGroupID,
  adID,
}) => {
  switch (levelSectionSelected) {
    case "adGroup":
      return findAdsGroupIndexById({ adsGroups, adGroupID }) >= 0;
    case "ad":
      return isAdPresentInAdsGroups({ adsGroups, adGroupID, adID });
    case "platform":
    case "assetsGroup":
    case undefined:
    case null:
    case "":
      return true;
    default:
      return true;
  }
};

export const withAdsGroupsList = (campaign) => {
  if (!campaign || typeof campaign !== "object" || Array.isArray(campaign)) {
    return { adsGroups: [] };
  }
  if (campaign.adsGroups == null) {
    return {
      ...campaign,
      adsGroups: [],
    };
  }
  return campaign;
};
